(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hp-card-btn--buy');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id), quantity: 1 }] })
    }).then(function (r) {
      if (r.ok) {
        btn.textContent = 'Added ✓';
        btn.style.background = '#10b981';
        setTimeout(function () {
          btn.textContent = 'Buy Now';
          btn.disabled = false;
          btn.style.background = '';
        }, 2000);
      } else {
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = 'Buy Now'; btn.disabled = false; }, 2000);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
